import React from 'react';
import useIsMobile from '../../hooks/useIsMobile';
import { t } from '@i18n/i18n';
import { useI18nInitNamespace } from '@i18n/useI18nInitNamespace';
import zerobounceBadgesTranslations from '@i18n/translations/components/zerobounce-badges/zerobounce-badges.json';
import useCurrentLanguage from '../../i18n/useCurrentLanguage';

import Spring1 from '../../images/why-us-badges/leader_spring.png';
import Spring2 from '../../images/why-us-badges/leader_sb_spring.png';
import Spring3 from '../../images/why-us-badges/momentum_leader_spring.png';
import Spring4 from '../../images/why-us-badges/best_roi_spring.png';
import Spring5 from '../../images/why-us-badges/best_rel_sb_spring.png';
import Spring6 from '../../images/why-us-badges/best_supp_sb_spring.png';
import Spring7 from '../../images/why-us-badges/easy_to_use_mm_spring.png';
import Spring8 from '../../images/why-us-badges/easy_setup_mm_spring.png';
import Spring9 from '../../images/why-us-badges/fastest_imp_sb_spring.png';
import Spring10 from '../../images/why-us-badges/high_performer_spring.png';
import Spring11 from '../../images/why-us-badges/high_performer_enter_spring.png';
import Spring12 from '../../images/why-us-badges/high_performer_sb_spring.png';
import Spring13 from '../../images/why-us-badges/high_performer_mm_spring.png';
import Spring14 from '../../images/why-us-badges/leader_europe_spring.png';
import Spring15 from '../../images/why-us-badges/leader_europe_sb_spring.png';
import Spring16 from '../../images/why-us-badges/leader_india_sb_spring.png';
import Spring17 from '../../images/why-us-badges/leader_asia_sb_spring.png';
import Spring18 from '../../images/why-us-badges/leader_asia_pac_sb_spring.png';
import Spring19 from '../../images/why-us-badges/leader_emea_spring.png';
import Spring20 from '../../images/why-us-badges/leader_emea_sm_spring.png';
import Spring21 from '../../images/why-us-badges/high_performer_asia_spring.png';
import Spring22 from '../../images/why-us-badges/high_performer_asia_mm_spring.png';
import Spring23 from '../../images/why-us-badges/high_performer_asia_sb_spring.png';
import Spring24 from '../../images/why-us-badges/high_perf_asia_pac_spring.png';
import Spring25 from '../../images/why-us-badges/high_perf_asia_pac_mm_spring.png';
import Spring26 from '../../images/why-us-badges/high_perf_asia_pac_sb_spring.png';
import Spring27 from '../../images/why-us-badges/high_perf_canada_spring.png';
import Spring28 from '../../images/why-us-badges/high_perf_emea_spring.png';
import Spring29 from '../../images/why-us-badges/high_perf_emea_sb_spring.png';
import Spring30 from '../../images/why-us-badges/high_perf_europe_spring.png';
import Spring31 from '../../images/why-us-badges/high_perf_europe_sb_spring.png';
import Spring32 from '../../images/why-us-badges/high_perf_india_spring.png';
import Spring33 from '../../images/why-us-badges/high_perf_india_mm_spring.png';
import Spring34 from '../../images/why-us-badges/high_perf_india_sb_spring.png';
import Spring35 from '../../images/why-us-badges/high_perf_latin_america_spring.png';
import Spring36 from '../../images/why-us-badges/high_perf_latin_america_sb_spring.png';
import Spring37 from '../../images/why-us-badges/users-love-us.webp';

//ES Badges
import EsSpring1 from '../../images/why-us-badges/es_leader_spring.png';
import EsSpring2 from '../../images/why-us-badges/es_leader_pme_spring.png';
import EsSpring3 from '../../images/why-us-badges/es_leader_de_momentum_spring.png';
import EsSpring4 from '../../images/why-us-badges/es_best_roi_merc_int_spring.png';
import EsSpring5 from '../../images/why-us-badges/es_best_rel_pme_spring.png';
import EsSpring6 from '../../images/why-us-badges/es_best_supp_pme_spring.png';
import EsSpring7 from '../../images/why-us-badges/es_easy_to_use_merc_int_spring.png';
import EsSpring9 from '../../images/why-us-badges/es_easy_config_spring.png';
import EsSpring8 from '../../images/why-us-badges/es_faster_implement_pme_spring.png';
import EsSpring10 from '../../images/why-us-badges/es_high_perf_spring.png';
import EsSpring11 from '../../images/why-us-badges/es_high_perf_empresa_spring.png';
import EsSpring12 from '../../images/why-us-badges/es_high_perf_pme_spring.png';
import EsSpring13 from '../../images/why-us-badges/es_high_perf_merc_int_spring.png';
import EsSpring14 from '../../images/why-us-badges/es_leader_europe_spring.png';
import EsSpring15 from '../../images/why-us-badges/es_leader_europe_pme_spring.png';
import EsSpring16 from '../../images/why-us-badges/es_leader_india_spring.png';
import EsSpring17 from '../../images/why-us-badges/es_leader_asia_pme_spring.png';
import EsSpring18 from '../../images/why-us-badges/es_leader_asia_pac_pme_spring.png';
import EsSpring19 from '../../images/why-us-badges/es_leader_emea_spring.png';
import EsSpring20 from '../../images/why-us-badges/es_leader_emea_pme_spring.png';
import EsSpring21 from '../../images/why-us-badges/es_high_perf_asia_spring.png';
import EsSpring22 from '../../images/why-us-badges/es_high_perf_asia_pme_spring.png';
import EsSpring23 from '../../images/why-us-badges/es_high_perf_asia_merc_int_spring.png';
import EsSpring24 from '../../images/why-us-badges/es_high_perf_asia_pac_spring.png';
import EsSpring25 from '../../images/why-us-badges/es_high_perf_asia_pac_merc_int_spring.png';
import EsSpring26 from '../../images/why-us-badges/es_high_perf_asia_pac_pme_spring.png';
import EsSpring27 from '../../images/why-us-badges/es_high_perf_canada_spring.png';
import EsSpring28 from '../../images/why-us-badges/es_high_perf_emea_spring.png';
import EsSpring29 from '../../images/why-us-badges/es_high_perf_emea_pme_spring.png';
import EsSpring30 from '../../images/why-us-badges/es_high_perf_europe_spring.png';
import EsSpring31 from '../../images/why-us-badges/es_high_perf_europe_pme_spring.png';
import EsSpring32 from '../../images/why-us-badges/es_high_perf_america_lat_spring.png';
import EsSpring33 from '../../images/why-us-badges/es_high_perf_america_lat_pme_spring.png';
import EsSpring34 from '../../images/why-us-badges/es_high_perf_india_spring.png';
import EsSpring35 from '../../images/why-us-badges/es_high_perf_india_pme__spring.png';
import EsSpring36 from '../../images/why-us-badges/es_high_perf_india_merc_int__spring.png';

import CloudflareImage from '../cloudflare-image/CloudflareImage';
import { getCookiePreferences } from '../accept-cookies';
import Carousel from '../carousel/carousel';
import { StyledDiv } from '../../styles/generic/globalStyledComponents';

const ZerobounceBadges = ({ noLogos = false, arrowsColor = '', style, onlyDots = false }) => {
  useI18nInitNamespace('zerobounceBadges', zerobounceBadgesTranslations, true);
  const isMobile = useIsMobile();
  const { isEs } = useCurrentLanguage();

  const preferences = getCookiePreferences();
  const hasGivenConsent = preferences?.advertising;

  const imgs = isEs
    ? [
        EsSpring1,
        EsSpring2,
        EsSpring3,
        EsSpring4,
        EsSpring5,
        EsSpring6,
        EsSpring7,
        EsSpring9,
        EsSpring8,
        EsSpring10,
        EsSpring11,
        EsSpring12,
        EsSpring13,
        EsSpring14,
        EsSpring15,
        EsSpring16,
        EsSpring17,
        EsSpring18,
        EsSpring19,
        EsSpring20,
        EsSpring21,
        EsSpring22,
        EsSpring23,
        EsSpring24,
        EsSpring25,
        EsSpring26,
        EsSpring27,
        EsSpring28,
        EsSpring29,
        EsSpring30,
        EsSpring31,
        EsSpring32,
        EsSpring33,
        EsSpring34,
        EsSpring35,
        EsSpring36,
        Spring37,
      ]
    : [
        Spring1,
        Spring2,
        Spring3,
        Spring4,
        Spring5,
        Spring6,
        Spring7,
        Spring8,
        Spring9,
        Spring10,
        Spring11,
        Spring12,
        Spring13,
        Spring14,
        Spring15,
        Spring16,
        Spring17,
        Spring18,
        Spring19,
        Spring20,
        Spring21,
        Spring22,
        Spring23,
        Spring24,
        Spring25,
        Spring26,
        Spring27,
        Spring28,
        Spring29,
        Spring30,
        Spring31,
        Spring32,
        Spring33,
        Spring34,
        Spring35,
        Spring36,
        Spring37,
      ];

  const winterBadges = () => {
    const arr = [];
    for (let i = 0; i < 37; i++) {
      arr.push({
        image: imgs[i],
        alt: t(`spring_${i + 1}`),
        id: `badges_${i + 1}`,
      });
    }

    return arr;
  };

  return (
    <StyledDiv maxWidth="920px" data-margin="0 auto">
      <Carousel
        slidesToShow={isMobile ? 1 : 4}
        speed={5000}
        loop={true}
        autoplay
        dots={onlyDots || isMobile}
        arrows={!isMobile && !onlyDots}
        color={arrowsColor}
      >
        {winterBadges().map((badge, idx) => (
          <CloudflareImage
            id={badge.id}
            className="badge_item"
            key={idx}
            src={badge.image}
            alt={badge.alt}
            isSliderComponent
            width="180"
            height="240"
            loading="lazy"
          />
        ))}
      </Carousel>
      {!noLogos && hasGivenConsent && (
        <>
          <div className="badges-reviews">
            <div className="badges-reviews-inner" style={style}>
              <a
                href={isEs ? 'https://www.capterra.es/software/169340/zerobounce' : 'https://www.capterra.com/p/169340/ZeroBounce'}
                title="Read reviews of ZeroBounce on Capterra"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  id="badges_capterra"
                  width="200"
                  height="66"
                  src="https://assets.capterra.com/badge/d5abce69a026e0bd85fa5f74c3f556ac.svg?v=2116563&p=169340"
                  alt={t('Capterra_review_logo', true)}
                />
              </a>
              <a
                href="https://www.g2.com/products/zerobounce/reviews?utm_source=review-widget"
                title="Read reviews of ZeroBounce on G2"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  id="badges_g2_review"
                  width="200"
                  height="100"
                  alt={t('G2_review_logo', true)}
                  src="https://www.g2.com/products/zerobounce/widgets/stars?color=white&amp;type=read"
                />
              </a>
            </div>
          </div>
        </>
      )}
    </StyledDiv>
  );
};

export default ZerobounceBadges;
